// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nt7zU","toggleWrap":"styles_toggleWrap__1XhKx","content":"styles_content__2dXmm","selectAreaCode":"styles_selectAreaCode__3LqBU"};